/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import FacilityService from "../../services/FacilityService";
import UserService from "../../services/UserService";
import {If} from "../../utils/Controls";
import {AntdPaging, AntdSelect, AntdTag} from "../../utils/Antd";
import util from "../../utils/util";
import Tabs, {PageHeading} from "./Tabs";
import edit from "../assets/icons/pen-to-square-solid.svg"
import xmark from "../assets/icons/circle-xmark-solid.svg"

import {
    Input,
    Button,
    message,
    Modal,
    Tag,
} from 'antd';
import ProgrammeSelect from '../fleet/ProgrammeSelect';
import {
    ExclamationCircleOutlined,
    GlobalOutlined,
} from '@ant-design/icons';
const { confirm } = Modal;

// ─── Eswatini regions ────────────────────────────────────────────────────────
const REGIONS = [
    { id: 'Hhohho',      name: 'Hhohho'      },
    { id: 'Manzini',     name: 'Manzini'      },
    { id: 'Shiselweni',  name: 'Shiselweni'   },
    { id: 'Lubombo',     name: 'Lubombo'      },
];

// Detect if a role title suggests regional scope
const isRegionRole = (roleTitle) => {
    if (!roleTitle) return false;
    return /region/i.test(roleTitle);
};

export default function User() {

    const [result,  setResult]  = useState({ data: [], page: {} });
    const [result2, setResult2] = useState({ data: [], page: {} });
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef  = useRef();
    const [roles, setRoles] = useState([]);

    const isNational = util.isNational();

    const list = (p, ps) => {
        sdataRef.current.p  = p  || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        util.showLoader();

        UserService.users(sdataRef.current).then(({ data }) => {
            setResult(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });

        UserService.usersCount(sdataRef.current).then(({ data }) => {
            setResult2(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });
    };

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this user?',
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                util.showLoader();
                UserService.deleteUser(id).then(({ data }) => {
                    message.success(data.message || 'Deleted');
                    list();
                }).catch(e => {
                    message.error(e.message);
                }).finally(() => {
                    util.hideLoader();
                });
            },
        });
    };

    const [clients, setClients] = useState([]);
    useEffect(() => {
        FacilityService.all({ status: 1, include_me: 'Y' }).then(res => {
            let allClients = res.data.result.data.map(v => ({
                id: v.id, name: v.business_name,
                is_national: v.is_national, is_me: v.is_me,
            }));
            setClients(allClients);
        });
    }, []);

    useEffect(() => {
        list();
        UserService.roles({ all: true }).then(res => { setRoles([...res.data.result.data]); });
        return () => { message.destroy(); };
    }, []);

    const blockStyle = {
        backgroundColor: 'rgba(173, 216, 230, 0.5)',
        border: '1px solid #ccc',
        padding: '10px',
        flex: '1 1 100px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '16px',
        margin: '10px',
    };
    const containerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    };

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto">
                    <p style={{ fontSize: '20px', textAlign: 'center', fontWeight: 'bold' }}>REGISTERED USERS</p>
                    <div style={containerStyle}>
                        {result2.data.map((i, v) => (
                            <div key={v} style={blockStyle}>
                                <p>{i.role}</p>
                                <p>{i.registered_users}</p>
                            </div>
                        ))}
                    </div>
                    <PageHeading />
                </div>
                <div className="my-auto ml-auto"></div>
            </div>

            <div className="page-pad">
                <div className="tabbable-custom">
                    <Tabs active="users" />
                    <div className="tab-content">
                        <div className="tab-pane fade1 show active">
                            {result.data.length > 0 && (
                                <div className="text-secondary mb8">
                                    Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                                </div>
                            )}

                            <div className="d-flex tbl-search-head">
                                <div className="my-auto">
                                    <SearchForm dataRef={sdataRef} onSearch={list} />
                                </div>
                                <div className="ml-auto my-auto">
                                    <Button type="primary" onClick={() => formRef.current.openForm()}>
                                        <i className="fa fa-plus mr5"></i> Add New User
                                    </Button>
                                </div>
                            </div>

                            <If cond={result.data.length}>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-md table-striped table-hover m-0">
                                        <thead className="thead-light text-uppercase table-text-vmid">
                                            <tr>
                                                <th className="w20">SN</th>
                                                <th className="w150">First Name</th>
                                                <th className="w150">Last Name</th>
                                                <th className="w180">Role</th>
                                                <th>Email</th>
                                                <th className="w120">Mobile No.</th>
                                                <th className="w100">Username</th>
                                                <th className="w60">Status</th>
                                                {isNational ? <th className="w120">Facility / Region</th> : null}
                                                <th className="w70"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-text-top">
                                            {result.data.map((v, i) => (
                                                <tr key={i}>
                                                    <td>{result.page.start + i + 1}.</td>
                                                    <td>{v.fname}</td>
                                                    <td>{v.lname}</td>
                                                    <td>{v.role}</td>
                                                    <td>{v.email}</td>
                                                    <td>{v.mobile}</td>
                                                    <td>{v.username}</td>
                                                    <td className="nowrap">
                                                        {v.status
                                                            ? <AntdTag type="success">Active</AntdTag>
                                                            : <AntdTag type="danger">Inactive</AntdTag>}
                                                    </td>
                                                    {isNational ? (
                                                        <td>
                                                            {v.region ? (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                                                    <GlobalOutlined style={{ color: '#722ed1', fontSize: 11 }} />
                                                                    <span style={{ fontSize: 12, color: '#722ed1', fontWeight: 600 }}>{v.region}</span>
                                                                    <Tag color="purple" style={{ fontSize: 9, margin: 0 }}>Region</Tag>
                                                                </span>
                                                            ) : (
                                                                <span style={{ fontSize: 12 }}>{v.facility || '—'}</span>
                                                            )}
                                                        </td>
                                                    ) : null}
                                                    <td className="text-center">
                                                        <Button.Group size="small">
                                                            <Button type="default" onClick={() => formRef.current.openForm(v)}>
                                                                <img src={edit} alt='' className='mr5' height={15} />
                                                            </Button>
                                                            <Button type="default" onClick={() => deleteRecord(v.id)}>
                                                                <img src={xmark} alt='' className='mr5' height={15} />
                                                            </Button>
                                                        </Button.Group>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex tbl-foot-bx">
                                    <AntdPaging
                                        onChange={list}
                                        total={result.page.total_records}
                                        current={result.page.cur_page}
                                        pageSize={sdataRef.current.ps}
                                        showSizeChanger
                                    />
                                </div>
                            </If>
                            <If cond={!result.data.length}>
                                <div className="no-rec">No record found</div>
                            </If>
                        </div>
                    </div>
                </div>
            </div>

            <AddForm
                ref={formRef}
                callback={list}
                pageno={sdataRef.current.p}
                roles={roles}
                clients={clients}
            />
        </div>
    );
}

// ─── Search Form ──────────────────────────────────────────────────────────────
const SearchForm = (props) => {
    let { dataRef, onSearch } = props;
    let [data, setData] = useState({ ...dataRef.current });

    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    };

    useEffect(() => {
        dataRef.current = { ...data };
    }, [data]);

    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div>
                    <Input placeholder="Search" allowClear
                        value={data.k} onChange={e => handleChange(e.target.value, 'k')} />
                </div>
                <div>
                    <Button type="primary"
                        icon={<i className="fa fa-search fs13"></i>}
                        onClick={() => onSearch()} />
                </div>
            </div>
        </form>
    );
};

// ─── Add / Edit Form ──────────────────────────────────────────────────────────
const AddForm = forwardRef((props, ref) => {

    let { callback, pageno, roles, clients } = props;
    const [showForm, setShowForm] = useState(false);
    let [data, setData] = useState({});

    const isNational = util.isNational();

    // Resolve selected role's title to detect region role
    const selectedRole      = roles.find(r => String(r.id) === String(data.role_id));
    const selectedRoleTitle = selectedRole?.title || '';
    const showRegion        = isNational && isRegionRole(selectedRoleTitle);
    // When region role is selected, facility becomes optional
    const showFacility      = isNational && !showRegion;

    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    };

    // When role changes — clear conflicting fields
    const handleRoleChange = (v) => {
        const role = roles.find(r => String(r.id) === String(v));
        const isReg = isRegionRole(role?.title || '');
        setData(prev => ({
            ...prev,
            role_id:   v,
            region:    isReg ? (prev.region || '') : '',   // keep region if switching between region roles
            client_id: isReg ? null : (prev.client_id),    // clear facility when switching to region role
        }));
    };

    const save = () => {
        message.destroy();
        util.showLoader();
        UserService.saveUser(data).then(({ data: res }) => {
            message.success(res.message || 'Saved');
            callback(data.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });
    };

    const closeForm = () => { setShowForm(false); };

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            setData(dtl ? { ...dtl } : { status: '1' });
            setShowForm(true);
        },
    }));

    return (
        <Modal
            title={`${data.id ? 'Edit' : 'Add'} User`}
            visible={showForm}
            okText="Save"
            onOk={save}
            onCancel={closeForm}
            destroyOnClose
            maskClosable={false}
            width={800}
        >
            <form onSubmit={e => { e.preventDefault(); save(); }} autoComplete="off" spellCheck="false">
                <div className="row mingap">

                    {/* Role */}
                    <div className="col-md-4 form-group">
                        <label className="req">Role</label>
                        <AntdSelect
                            options={roles}
                            value={data.role_id}
                            onChange={handleRoleChange}
                        />
                    </div>

                    {/* First Name */}
                    <div className="col-md-4 form-group">
                        <label className="req">First Name</label>
                        <Input value={data.fname || ''} onChange={e => handleChange(e.target.value, 'fname')} />
                    </div>

                    {/* Last Name */}
                    <div className="col-md-4 form-group">
                        <label>Last Name</label>
                        <Input value={data.lname || ''} onChange={e => handleChange(e.target.value, 'lname')} />
                    </div>

                    {/* Email */}
                    <div className="col-md-4 form-group">
                        <label className="req">Email</label>
                        <Input value={data.email || ''} onChange={e => handleChange(e.target.value, 'email')} />
                    </div>

                    {/* Mobile */}
                    <div className="col-md-4 form-group">
                        <label className="req">Mobile</label>
                        <Input value={data.mobile || ''} onChange={e => handleChange(e.target.value, 'mobile')} />
                    </div>

                    {/* Username */}
                    <div className="col-md-4 form-group">
                        <label className="req">Username</label>
                        <Input value={data.username || ''} onChange={e => handleChange(e.target.value, 'username')} />
                    </div>

                    {/* Password */}
                    <div className="col-md-4 form-group">
                        <label>Password</label>
                        <Input onChange={e => handleChange(e.target.value, 'password')} />
                    </div>

                    {/* Status */}
                    <div className="col-md-4 form-group">
                        <label className="req">Status</label>
                        <AntdSelect
                            options={[{ value: '1', label: 'Active' }, { value: '0', label: 'Inactive' }]}
                            value={data.status}
                            onChange={v => handleChange(v, 'status')}
                        />
                    </div>

                    {/* ── Assigned Programme — shows when role has fleet_scope_programme ── */}
                    {isNational && (
                        <div className="col-md-4 form-group">
                            <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:12 }}>
                                Programme
                                <span style={{ fontSize:10, color:'#888', fontWeight:400 }}>(required for Programme Manager role)</span>
                            </label>
                            <ProgrammeSelect
                                value={data.assigned_programme || ''}
                                onChange={v => handleChange(v || '', 'assigned_programme')}
                            />
                            <div style={{ fontSize:11, color:'#888', marginTop:3 }}>
                                Set when this user has the "Programme Scope" fleet module assigned.
                            </div>
                        </div>
                    )}

                    {/* ── Region — shows when Role title contains "region" ── */}
                    {showRegion && (
                        <div className="col-md-4 form-group">
                            <label className="req" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <GlobalOutlined style={{ color: '#722ed1' }} />
                                Region
                                <span style={{ fontSize: 10, color: '#722ed1', fontWeight: 400, marginLeft: 4 }}>
                                    (data access scope)
                                </span>
                            </label>
                            <AntdSelect
                                placeholder="Select region"
                                options={REGIONS}
                                value={data.region || undefined}
                                onChange={v => handleChange(v, 'region')}
                                allowClear
                            />
                            <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                                This user will only see data from the selected region.
                            </div>
                        </div>
                    )}

                    {/* ── Facility — shows for non-region roles (national users only) ── */}
                    {showFacility && (
                        <div className="col-md-4 form-group">
                            <label className="req">Facility</label>
                            <AntdSelect
                                placeholder="All Facilities"
                                allowClear
                                showSearch
                                options={clients}
                                value={data.client_id}
                                onChange={v => {
                                    data.item_id = null;
                                    handleChange(v, 'client_id');
                                }}
                            />
                        </div>
                    )}

                </div>

                {/* Info banner when region role selected */}
                {showRegion && (
                    <div style={{
                        background: '#f9f0ff', border: '1px solid #d3adf7',
                        borderRadius: 6, padding: '8px 14px', marginTop: 4,
                        fontSize: 12, color: '#531dab', display: 'flex', gap: 8,
                    }}>
                        <GlobalOutlined style={{ marginTop: 2 }} />
                        <span>
                            <strong>Region Admin</strong> — this user will be scoped to all facilities and vehicles
                            in the selected region. No specific facility assignment is needed.
                        </span>
                    </div>
                )}
            </form>
        </Modal>
    );
});